module.exports = __webpack_public_path__ + "static/img/poster_sl02.78229673.jpg";